import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32cd0aac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"height":"100%"} }
const _hoisted_2 = { class: "right-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont" }, "", -1))
const _hoisted_4 = {
  key: 0,
  class: "chat-unit-list"
}
const _hoisted_5 = {
  key: 1,
  class: "empty-chat-list"
}
const _hoisted_6 = {
  key: 2,
  class: "empty-chat-list"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "offline-container" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont" }, "")
], -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 您已将手机值班状态设置为离线 ")
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 3,
  class: "empty-chat-list"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "offline-container" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont" }, "")
], -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 连接中... ")
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { style: {"padding":"24px 26px"} }
const _hoisted_15 = { style: {"display":"flex"} }
const _hoisted_16 = { style: {"width":"50%","text-align":"center","border-top":"1px solid rgb(235, 237, 240)","color":"rgb(238, 10, 36)","height":"48px","line-height":"48px"} }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 复制微信 ")
const _hoisted_18 = { style: {"width":"50%","text-align":"center","border-top":"1px solid rgb(235, 237, 240)","color":"rgb(238, 10, 36)","height":"48px","line-height":"48px"} }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 复制手机 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_van_badge = _resolveComponent("van-badge")!
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_chat_unit = _resolveComponent("chat-unit")!
  const _component_bottom_bar = _resolveComponent("bottom-bar")!
  const _component_van_dialog = _resolveComponent("van-dialog")!
  const _directive_clipboard = _resolveDirective("clipboard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_nav_bar, { title: "对话" }, {
        left: _withCtx(() => [
          _createVNode(_component_router_link, {
            class: "left-search-link",
            to: { name: 'chatSearch' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_icon, {
                name: "search",
                class: "left-search-icon"
              })
            ]),
            _: 1
          })
        ]),
        right: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_van_icon, {
              name: "service-o",
              style: {"font-size":"22px","margin-right":"10px"},
              onClick: _ctx.displayAdvisorDialog
            }, null, 8, ["onClick"]),
            _createVNode(_component_router_link, { to: { name: 'notificationList' } }, {
              default: _withCtx(() => [
                _createVNode(_component_van_badge, {
                  content: _ctx.unreadCount || null
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["content"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      (_ctx.isOnDuty)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.talkList, (visitor) => {
              return (_openBlock(), _createBlock(_component_chat_unit, {
                key: visitor.uid,
                visitor: visitor
              }, null, 8, ["visitor"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (!_ctx.talkList.length && _ctx.isOnDuty)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 目前没有正在进行中的对话 "))
        : _createCommentVNode("", true),
      (!_ctx.isOnDuty && !_ctx.isPageReconnecting)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
        : _createCommentVNode("", true),
      (!_ctx.isOnDuty && _ctx.isPageReconnecting)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
        : _createCommentVNode("", true),
      _createVNode(_component_bottom_bar)
    ]),
    _createVNode(_component_van_dialog, {
      show: _ctx.showAdvisorDialog,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showAdvisorDialog) = $event)),
      "show-confirm-button": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", null, "我是您的专属运营顾问-" + _toDisplayString(_ctx.advisor.name) + "，欢迎联系我", 1),
          _createElementVNode("div", null, "微信：" + _toDisplayString(_ctx.advisor.wechat), 1),
          _createElementVNode("div", null, "电话：" + _toDisplayString(_ctx.advisor.mobile.slice(0, 3)) + "-" + _toDisplayString(_ctx.advisor.mobile.slice(3, 7)) + "-" + _toDisplayString(_ctx.advisor.mobile.slice(7, 11)), 1)
        ]),
        _renderSlot(_ctx.$slots, "footer", {}, () => [
          _createElementVNode("div", _hoisted_15, [
            _withDirectives(_createElementVNode("div", _hoisted_16, [
              _createVNode(_component_van_icon, { name: "wechat" }),
              _hoisted_17
            ], 512), [
              [_directive_clipboard, _ctx.advisor.wechat, "copy"],
              [_directive_clipboard, _ctx.closeAdvisorDialog, "success"]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_18, [
              _createVNode(_component_van_icon, { name: "phone-o" }),
              _hoisted_19
            ], 512), [
              [_directive_clipboard, _ctx.advisor.mobile, "copy"],
              [_directive_clipboard, _ctx.closeAdvisorDialog, "success"]
            ])
          ])
        ], true)
      ]),
      _: 3
    }, 8, ["show"])
  ], 64))
}